// Two fixes for the "Complete care" upsell inside the cart drawer.
//
// 1. Quantity: the upsell renders inside <cart-drawer-items>, whose Dawn CartItems
//    class treats any bubbling `change` as an edit to an existing cart line. These
//    inputs belong to an add-to-cart form and carry no data-index, so the line is
//    undefined and /cart/change.js fails. Stop the event during the capture phase.
//
// 2. Variant: Kaching (or any app that rewrites input[name="id"]) keeps the first
//    such input on the page in sync with its own selector, so the upsell submits
//    the PDP variant instead of its own. Restore the correct id from the form's
//    data attribute at submit time, before Dawn's ProductForm builds its FormData.
//
// Both listeners are bound to document so they survive every drawer re-render.
(function () {
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest('.cart-complete-care')) return;

      // The capture-phase stop also skips QuantityInput.onInputChange, whose only
      // job is validateQtyRules(). Call it directly so the minus button still
      // greys out at min.
      var quantityInput = target.closest('quantity-input');
      if (quantityInput && typeof quantityInput.validateQtyRules === 'function') {
        quantityInput.validateQtyRules();
      }

      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('cart-cc__form')) return;

      var expected = form.getAttribute('data-cc-variant-id');
      var input = form.querySelector('input[name="id"]');
      if (expected && input && input.value !== expected) {
        input.value = expected;
      }
    },
    true
  );
})();
